import styled from 'styled-components';
import { Currency } from '../../ui/ItemCard/styled';
import { Breakpoints } from '../../../styled/constants';
import { getSafeAreaValue } from '../../../styled/theme/helpers/getSafeAreaValue';

export const PriceValue = styled.span`
  display: inline-flex;
  align-items: center;

  ${Currency} {
    margin: 0;
  }

  svg {
    margin: 0;
  }
`;

export const SearchResultMapContainer = styled.div<{
  $markersLoading: boolean;
}>`
  opacity: ${({ $markersLoading }) => ($markersLoading ? 0.9 : 1)};
  transition: opacity 0.2s ease-in-out;
  margin-bottom: ${({ theme }) => getSafeAreaValue(theme, 'bottom', 0, 20)};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    margin-bottom: 140px;
  }
`;

export const MapContainerStub = styled.div`
  height: 450px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    height: 660px;
  }
`;
